import { RequestPost } from "../apiClient/api/RequestService";
import { logout } from "./Logout";

function updateToken(objData){
    return { type : "UPDATE_TOKEN", data: objData}
}

function refreshToken (objData) {
    return async dispatch => {
        const res = await RequestPost(`/v1/authentication/refresh-token`, objData)

        if (res?.return_code === 1) {
           return dispatch(updateToken(res.data))
        } 
        else {
            return dispatch(logout(objData.access_token, objData.refresh_token))
        }
    }
}

export { refreshToken  }